import apiFetch from "@/src/utils/apiFetch";
import { isCabinet, uid } from "@/src/utils/utils";
import { useEffect, useState } from "react";

export function RetrievePendingExamResultsButton({
  patientId,
  parentId,
  onFound,
}: {
  patientId: string;
  parentId: string | null | undefined;
  onFound: (count: number) => void;
}) {
  const [shouldHide, setShouldHide] = useState(isCabinet() ? true : false);
  const [isLoading, setIsLoading] = useState(true);
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (isCabinet()) return;
    checkPendingResults();
  }, []);

  async function checkPendingResults() {
    setIsLoading(true);
    let result = await apiFetch("samples", "apiCheckAllPendingExamResults", {
      patientId,
      parentId: null,
    });


    if (result?.count) {
      onFound?.(result?.count);
    }

    setCount(result?.count);
    setIsLoading(false);
    if (count == 0) {
      setTimeout(() => {
        setShouldHide(true);
      }, 2000);
      return;
    }
  }

  if (!patientId) return null;
  if (shouldHide) return null;
  if (isLoading)
    return (
      <div key={uid()} className="fade gray center p10">
        Recherche de nouveaux résultats...
      </div>
    );

  if (count === 0)
    return (
      <div key={uid()} className=" fade gray center p10">
        Aucun nouveau résultat
      </div>
    );
  if (count > 0)
    return (
      <div key={uid()} className="fade bold center p10">
        {count} Nouveaux résultats trouvés
      </div>
    );
}
